






























import { Component } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';

@Component<MixinDialog>({
  created() {
    this.$pdc.bus!.on('equipments:get-kit:open', this.open);
  },
  beforeDestroy() {
    this.$pdc.bus!.off('equipments:get-kit:open', this.open);
  },
})
export default class EquipmentsGetKitDialog extends MixinDialog {
  buy() {
    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('Kit PurchaseInitiated');

    window.open('http://www.podosmart.tech/?add-to-cart=15994&quantity=1', '_blank');
    this.close();
  }
}
